export default {
  quot: [34],
  amp: [38],
  apos: [39],
  lt: [60],
  gt: [62]
};
